<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">過去画像登録</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">画像ファイル名</label>
          <div class="list-input-content">
            <input type="text" id="txti_ImageFileName" #txti_ImageFileName plessInputTextSub class="input-with-button text-label-required" 
              [halfOnly]="true" [required]="true" [maxLength]="12" style="width: 12rem;" [tabindex]="0"
              (ngModelChange)="eventImageFileName_deleteCommaHandler()" [(ngModel)]="this.kymw1705Model.imageFileName">
            <button id="btn_Image" class="btn-secondary" (click)="eventClickHandler_Display()"
              [tabindex]="0">表示</button>
          </div>
        </div>
        <div>
          <img id="img_PastImage" src="{{this.kymw1705Model.imagePreviewUrl}}" forcedEnabledMode="true"
            #img_PastImage verticalAlign="middle" horizontalAlign="center" autoLoad="true" cachePolicy="off"
            cacheAsBitmap="false" *ngIf="this.kymw1705Model.imagePreviewUrl != ''" (load)="setImageScale()">
        </div>
      </div>
    </td>
  </tr>
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Update" class="btn-primary" (click)="eventClickHandler_Register()" [tabindex]="0">登録</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClickHandler_Close()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>